import { render } from "./TabNavigation.vue?vue&type=template&id=e95f77ee&scoped=true"
import script from "./TabNavigation.vue?vue&type=script&lang=js"
export * from "./TabNavigation.vue?vue&type=script&lang=js"

import "./styles/TabNavigation.css?vue&type=style&index=0&id=e95f77ee&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e95f77ee"]])

export default __exports__